export const IGNORE_ERROR_CODE = [
	"NETWORK_ERROR",
	"INVALID_REQUEST",
	"TOKEN_EXPIRED"
	// "invalid password",
	// "invalid id or password",
	// "invalid certification",
	// "invalid phone number",
	// "not found certification",
	// "not found employee",
	// "invalid request",
	// "invalid department",
	// "File does not belong to the employee",
	// "TaxAccountant not found",
	// "CustomerManagement not found",
	// "Customer not found",
	// "File not found",
	// "Request not found",
	// "can't change status on DEFAULT to $nextStatus",
	// "can't change status on REJECTED to $nextStatus",
	// "can't change status on $status to $nextStatus",
	// "first approver not approved yet",
	// "invalid department $department",
	// "SalesManagement not found",
	// "sales management is not editable",
	// "can't change approver status to DEFAULT",
	// "can't change approver status",
	// "not found visit history",
	// "duplicated customer",
	// "already approved",
	// "already rejected",
	// "first approver not approved yet",
	// "Full authentication is required to access this resource"
];
